module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [(_vm.showBackBtn) ? _c('span', {
    staticClass: "go-back-btn",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("首页")]) : _vm._e(), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), (_vm.$route.meta.showTab) ? _c('footer', {
    staticClass: "fixed flex"
  }, [_c('router-link', {
    attrs: {
      "to": "index"
    }
  }, [_c('span', {
    staticClass: "icon icon-home"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "orderlist"
    }
  }, [_c('span', {
    staticClass: "icon icon-order"
  }, [_vm._v("订单")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "usercenter"
    }
  }, [_c('span', {
    staticClass: "icon icon-user"
  }, [_vm._v("我的")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-352516be","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 423
// module chunks = 7